"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Clock, PhoneCall, Calendar } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const appointmentTypes = [{
  id: "consultation",
  name: "Introductory telephone consultation",
  duration: "10 minutes",
  price: "Free",
  highlight: true
}, {
  id: "initial-assessment",
  name: "Initial assessment",
  duration: "60 minutes",
  price: "£100",
  highlight: false
}, {
  id: "longer-follow-up",
  name: "Longer follow-up",
  duration: "50 minutes",
  price: "£100",
  highlight: false
}, {
  id: "shorter-follow-up",
  name: "Shorter follow-up",
  duration: "25 minutes",
  price: "£50",
  highlight: false
}, {
  id: "pre-postnatal",
  name: "Pre or postnatal appointment",
  duration: "50 minutes",
  price: "£100",
  highlight: false
}];
export default function PelvicPricing() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.4,
        ease: "easeOut"
      }
    }
  };
  return <section id="pelvichealthpricing" data-nav="light" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-10 md:mb-14 text-center">
          <h2 className="font-display text-primary text-3xl md:text-4xl tracking-wide font-bold">
            Pelvic health physiotherapy
          </h2>
          <div className="mt-4 mx-auto w-12 h-1 bg-accent rounded-full" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }} className="flex flex-col gap-4">
          {appointmentTypes.map((item, i) => <motion.div key={item.id} data-index={i} variants={itemVariants} className="card p-5 md:p-6 transition-all">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="space-y-1.5 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-display font-semibold text-primary text-lg md:text-xl">
                      {item.name}
                    </span>
                  </div>
                  <div className="flex items-center text-muted-foreground text-sm gap-1.5">
                    <Clock className="size-4 text-accent shrink-0" />
                    <span>{item.duration}</span>
                  </div>
                </div>

                <div className="flex items-center justify-between sm:justify-end gap-5 pt-2 sm:pt-0 border-t border-border sm:border-t-0">
                  <span className="font-display font-bold text-xl md:text-2xl text-primary">
                    {item.price}
                  </span>
                  <Button asChild variant={item.highlight ? "default" : "outline"} size="sm" className={item.highlight ? "bg-primary text-primary-foreground hover:bg-primary-hover shadow-xs" : "border-primary text-primary hover:bg-secondary"}>
                    <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
                      {item.highlight ? <>
                          <PhoneCall className="size-3.5" />
                          <span>Book call</span>
                        </> : <>
                          <SafeHydrate><Calendar className="size-3.5" /></SafeHydrate>
                          <span>Book</span>
                        </>}
                    </Link>
                  </Button>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}